import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { gql } from 'apollo-boost';
import { Mutation } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";

import {name , url , description , validateForm , image } from '../../../validations/validation';



import CompanyProfileStrength from './company-profile-strength.component';
import ExplorePremium from '../explore-premium/explore-premium-component';
import CompanyProfileLink from './company-profile-link.component';

// styles and icons
import profileIcon from '../../../images/personal.svg';
import Logo from '../../../images/logo.png';
import Pp from './images/Pp.png'
import AddIcon from '@material-ui/icons/Add';
import {  Container, Row, Col, Modal } from 'react-bootstrap';
import { Paper, Button, TextField, Typography, InputLabel, FormControl, Select } from '@material-ui/core';
import Loader from 'react-loader-spinner';
import Skeleton from '@material-ui/lab/Skeleton';

class CompanyProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: '',
            errors : {
                name : '',
                description : '',
                url : '',
                profilePic : ''
            }
        }
    }
    getUserData = () => {
        if (localStorage.jwt) {
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            let id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data
            apolloFetch({
                query:
                    `query($user_id : Int !){
                            user(id: $user_id){
                                email
                            company {
                                id
                                name
                                website_url
                                description
                                website_url
                                logo{url}
                                Industry{
                                    id
                                    context
                                    name
                                    name_en
                                    name_ar
                                  }
                              }
                      }
                  }
                   `, variables: { user_id: id }
            })
                .then(res => {
                    if (res.data.user && res.data.user.company) {
                        let company = res.data.user.company;
                        this.setState({
                            ...this.state, company: company,
                            email : res.data.user.email , 
                            profilePic: company.logo ? company.logo.url : '', name: company.name,
                            websiteUrl: company.website_url,
                            description: company.description, industry: company.Industry ? company.Industry.id : ''
                        })
                    }
                })
            apolloFetch({
                query:
                    `query{
                          companyIndustryType{
                            id
                            context
                            name
                            name_en
                            name_ar
                            created_at
                            updated_at
                          }
                        }
                       `
            })
                .then(res => {
                    let industries = res.data.companyIndustryType;
                    if (industries) {
                        this.setState({ ...this.state, industries: industries });
                    }
                })
        }
    }
    handleChange = props => event => {
        if(props === 'profilePic'){
            if(event.target.files[0]){
                console.log(event)
               this.setState({ ...this.state, [props]: event.target.files[0] });
            }
        }
        else
        {
             this.setState({ ...this.state, [props]: event.target.value });
        }
        let errors = this.state.errors;

        switch (props) {
            case 'name':
                errors.name = name(event.target.value);
                break;
            case 'description':
                errors.description = description(event.target.value);
                break;
            case 'websiteUrl' : 
                errors.url = url(event.target.value);
                break;
            case 'profilePic' : 
                errors.profilePic = image(event.target.files[0]);
                break;
            default:
                break;
        }
    };
    checkImgUrl = (logo) => {
        var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
        if (logo && !regex.test(logo)) {
            console.log(logo);
            return logo = URL.createObjectURL(logo);
        } else {
            console.log(logo);
            return logo
        }
    }
    componentWillMount() {
        this.getUserData();
    }
    closeProfileEdit = () => this.setState({
        ...this.state, showProfileEdit: false,
        PhoneErrorMessage: '', nameErrorMessage: '',
        addressErrorMessage: '', headlinesErrorMessage: ''
    })
    render() {
        console.log(this.state);
        const apolloCache = new InMemoryCache({
            addTypename: false
        })
        const token = (localStorage.getItem('jwt')) ? JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token : '';

        const uploadLink = createUploadLink({
            uri: 'https://spreago.black-squares.com/graphql',
            headers: {
                authorization: token ? `Bearer ${token}` : ""
            }
        })
        const client = new ApolloClient({
            cache: apolloCache,
            link: uploadLink
        })
        if (!this.state.industries) {
            return (
                <div>
                    <Container className="pt-5 pb-4">
                        <Row>
                            <Col md={8}>
                                <Skeleton className="mb-2" variant="rect" animation="wave" height={460} />
                            </Col>
                            <Col md={4} className="pt-4">
                                <Skeleton variant="text" width={210} height={40} />
                                <Skeleton variant="rect" height={118} />
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        }
        else {
            return (
                <ApolloProvider client={client}>
                    <div>
                        <Container className=" pb-4">
                            <Row>
                                <Col className="pt-5" md={8}>
                                    <Paper className="p-3 mb-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                                        <Row className="m-0 mb-3 align-items-center justify-content-center">
                                            {/* profile image */}
                                            <Col md={4} className="text-left">
                                                <div className=" m-auto" style={{ width: "170px", height: "170px" }}>
                                                    <img
                                                        style={{ width: '100%', height: '100%' }}
                                                        className="shadow rounded-circle img-fluid"
                                                        src={(this.state.company.logo) ? this.state.company.logo.url : Pp}
                                                        alt="" />
                                                </div>
                                            </Col>
                                            <Col md={8}>
                                                <div>
                                                    <h5>{this.state.company.name?this.state.company.name : 'Company Name'}</h5>
                                                    <p>{this.state.company.Industry?this.state.company.Industry.name : ''}</p>
                                                </div>
                                                <div className="text-left p-0 d-inline-block ">
                                                    <div className="text-orange"><p className="mb-0">250</p></div>
                                                    <div className=""><p>Followers</p></div>
                                                </div>
                                                <div  className="text-left p-0 d-inline-block pl-3">
                                                    <div className="text-orange"><p className="mb-0">1,345</p></div>
                                                    <div className=""><p>Job Posts</p></div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Paper>
                                    <Paper className="p-3" style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                                        <Row >
                                            <Col md={12}>
                                                <Row className="m-0 mb-3 align-items-center">
                                                    <Col className="text-left p-0" xs={8}>
                                                        <h6 className="bold mb-0">
                                                            <span ><img src={profileIcon} alt="icon" className="pr-3 pb-1" /></span>
                                                            Basic Information
                                                        </h6>
                                                    </Col>
                                                    <Col className="text-right p-0" xs={4}>
                                                        <button
                                                            className="bg-transparent border-0"
                                                            onClick={e =>
                                                                this.setState({ ...this.state, showProfileEdit: true })}
                                                        >
                                                            <h6>Edit</h6>
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <Row className="m-0 bg-lightgrey p-3 mb-2">
                                                    <Col md={3}>
                                                        <p className="mb-0">Company Name</p>
                                                    </Col>
                                                    <Col md={9}>
                                                        <p className="mb-0">{(this.state.company.name) ? this.state.company.name : ''}</p>
                                                    </Col>
                                                </Row>
                                                <Row className="m-0 bg-lightgrey p-3 mb-2">
                                                    <Col md={3}>
                                                        <p className="mb-0">Industry</p>
                                                    </Col>
                                                    <Col md={9}>
                                                        <p className="mb-0">{(this.state.company.Industry) ? this.state.company.Industry.name : ''}</p>
                                                    </Col>
                                                </Row>
                                                <Row className="m-0 bg-lightgrey p-3 mb-2">
                                                    <Col md={3}>
                                                        <p className="mb-0">Email address</p>
                                                    </Col>
                                                    <Col md={9}>
                                                        <p className="mb-0">{(this.state.email) ? this.state.email : ''}</p>
                                                    </Col>
                                                </Row>
                                                <Row className="m-0 bg-lightgrey p-3 mb-2">
                                                    <Col md={3}>
                                                        <p className="mb-0">Website URL</p>
                                                    </Col>
                                                    <Col md={9}>
                                                        <p className="mb-0">{(this.state.company.website_url) ? this.state.company.website_url : ''}</p>
                                                    </Col>
                                                </Row>
                                                <Row className="m-0 bg-lightgrey p-3 mb-2">
                                                    <Col md={3}>
                                                        <p className="mb-0">Description</p>
                                                    </Col>
                                                    <Col md={9}>
                                                        <p className="mb-0">{(this.state.company.description) ? this.state.company.description : ''}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Paper>
                                </Col>
                                <Modal
                                    size="md"
                                    centered
                                    className="row m-0  pr-0"
                                    show={this.state.showProfileEdit}
                                    onHide={this.closeProfileEdit}>
                                    <Col xs={12} className="p-0">
                                        <Modal.Header className="p-2 pr-3 pl-3 bg-lightgrey" closeButton>
                                            <Modal.Title className="h5 ">Edit Company Profile</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body className="p-2">
                                            <div className="row m-0">
                                                {/* profile image */}
                                                <Col md={4} className="text-left">
                                                    <div className="p-relative m-auto" style={{ width: "170px", height: "170px" }}>
                                                        <img
                                                            style={{ width: '100%', height: '100%' }}
                                                            className="shadow rounded-circle img-fluid"
                                                            src={(this.state.profilePic) ? this.checkImgUrl(this.state.profilePic) : Pp}
                                                            alt="" />
                                                        <button
                                                            className="rounded-circle border-0 btn-orange-gradiant shadow p-absolute"
                                                            style={{ width: "45px", height: "45px", bottom: '0', right: '5px' }}
                                                        >
                                                            <label style={{ cursor: 'pointer' }} for="uploadCompanyProfile">
                                                                <AddIcon className="text-white" style={{ fontSize: "35px" }} />
                                                            </label>
                                                        </button>
                                                        <input
                                                            onChange={this.handleChange('profilePic')}
                                                            type="file"
                                                            accept='image/*'
                                                            className="d-none"
                                                            id="uploadCompanyProfile" 
                                                        />
                                                    </div>
                                                </Col>
                                                <Col xs={12} className="">
                                                    <Typography variant="subtitle1" className="text-danger">{this.state.errors.profilePic}</Typography>
                                                </Col>
                                                {/* Company information */}
                                                <Col md={12} className="pt-4">
                                                    <InputLabel className="" htmlFor="name">
                                                        <p className="mb-1"> Company Name</p>
                                                    </InputLabel>
                                                    <TextField
                                                        fullWidth
                                                        id="name"
                                                        color="primary"
                                                        variant="outlined"
                                                        value={this.state.name}
                                                        inputProps={{
                                                            value: this.state.name
                                                        }}
                                                        onChange={this.handleChange('name')}
                                                    />
                                                </Col>
                                                <Col xs={12} className="">
                                                    <Typography variant="subtitle1" className="text-danger">{this.state.errors.name}</Typography>
                                                </Col>
                                                <Col className="pt-2">
                                                    <InputLabel className="mb-1" htmlFor="industry-select">
                                                        Industry
                                                    </InputLabel>
                                                    <FormControl size="small" id="industry-select" fullWidth variant="outlined">
                                                        <Select
                                                            className="industry pt-2 pb-2"
                                                            onChange={this.handleChange('industry')}
                                                            inputProps={{
                                                                value: (this.state.industry) ? this.state.industry : ''
                                                            }}
                                                        >
                                                            {
                                                                this.state.industries ? this.state.industries.map(industry => {
                                                                    return (
                                                                        <option value={industry.id}>{industry.name}</option>
                                                                    );
                                                                }) : ''
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </Col>
                                                <Col md={12} className="pt-2">
                                                    <InputLabel className="" htmlFor="description">
                                                        <p className="mb-1"> Description</p>
                                                    </InputLabel>
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        rows="3"
                                                        color="primary"
                                                        variant="outlined"
                                                        defaultValue={this.state.description}
                                                        onChange={this.handleChange('description')}
                                                    />
                                                </Col>
                                                <Col xs={12} className="">
                                                    <Typography variant="subtitle1" className="text-danger">{this.state.errors.description}</Typography>
                                                </Col>
                                                <Col md={12} className="pt-2">
                                                    <InputLabel className="" htmlFor="url">
                                                        <p className="mb-1"> Website Url</p>
                                                    </InputLabel>
                                                    <TextField
                                                        id="url"
                                                        fullWidth
                                                        color="primary"
                                                        variant="outlined"
                                                        helperText="Ex: http://www.example.com"
                                                        inputProps={{
                                                            value: this.state.websiteUrl
                                                        }}
                                                        onChange={this.handleChange('websiteUrl')}
                                                    />
                                                </Col>
                                                <Col xs={12} className="">
                                                    <Typography variant="subtitle1" className="text-danger">{this.state.errors.url}</Typography>
                                                </Col>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer className="custom p-2 pt-3 border-0">
                                            <Row className="m-0 w-100">
                                                <Col xs={6} className="text-left pt-2">
                                                    <Button
                                                        type="button"
                                                        size="large"
                                                        className="btn-white-outline  pr-4 pl-4" variant="contained"
                                                        onClick={() => { this.closeProfileEdit() }}>
                                                        Cancel
                                                    </Button>
                                                </Col>
                                                <Col md={6} className="pt-2 text-right">
                                                    {(this.state.company.id) ?
                                                        <Mutation mutation={EDIT_DATA}>
                                                            {(companyEdit, { data, loading }) =>
                                                                <div>
                                                                    <Button
                                                                        type="button"
                                                                        size="large"
                                                                        className="btn-orange-gradiant pr-4 pl-4"
                                                                        variant="contained"
                                                                        onClick={() => {
                                                                            if (validateForm(this.state.errors)) {
                                                                                if (this.state.company.logo) {
                                                                                    if (this.state.profilePic === this.state.company.logo.url) {
                                                                                        companyEdit({
                                                                                            variables: {
                                                                                                company_id: this.state.company.id,
                                                                                                name: this.state.name,
                                                                                                website_url: this.state.websiteUrl,
                                                                                                description: this.state.Description,
                                                                                                company_industry_type_id: this.state.industry
                                                                                            }
                                                                                        }).then((res, loading) => {
                                                                                            if (res.data.companyEdit.Status.code === 200) {
                                                                                                this.setState({ ...this.state, company: res.data.companyEdit.company , showProfileEdit : false});
                                                                                                // this.props.history.push({
                                                                                                //     pathname: '/homepage'
                                                                                                // });
                                                                                                // window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                            }

                                                                                        }).catch((err) => console.log(err));
                                                                                    } else {
                                                                                        companyEdit({
                                                                                            variables: {
                                                                                                company_id: this.state.company.id,
                                                                                                name: this.state.name,
                                                                                                website_url: this.state.websiteUrl,
                                                                                                description: this.state.description,
                                                                                                logo: this.state.profilePic,
                                                                                                company_industry_type_id: this.state.industry
                                                                                            }
                                                                                        }).then((res, loading) => {
                                                                                            if (res.data.companyEdit.Status.code === 200) {
                                                                                                this.setState({ ...this.state, company: res.data.companyEdit.company , showProfileEdit : false});
                                                                                                // this.props.history.push({
                                                                                                //     pathname: '/homepage'
                                                                                                // });
                                                                                                // window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                            }

                                                                                        }).catch((err) => console.log(err));
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    companyEdit({
                                                                                        variables: {
                                                                                            company_id: this.state.company.id,
                                                                                            name: this.state.name,
                                                                                            website_url: this.state.websiteUrl,
                                                                                            description: this.state.description,
                                                                                            logo: this.state.profilePic,
                                                                                            company_industry_type_id: this.state.industry
                                                                                        }
                                                                                    }).then((res, loading) => {
                                                                                        if (res.data.companyEdit.Status.code === 200) {
                                                                                            this.setState({ ...this.state, company: res.data.companyEdit.company ,  showProfileEdit : false });
                                                                                            // this.props.history.push({
                                                                                            //     pathname: '/homepage'
                                                                                            // });
                                                                                            // window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                        }

                                                                                    }).catch((err) => console.log(err));
                                                                                }
                                                                            }
                                                                        }} >
                                                                        Save Changes
                                                                </Button>
                                                                    {loading &&
                                                                        <div className="loading">
                                                                            {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                            <Loader
                                                                                type="TailSpin"
                                                                                color="white"
                                                                                height={50}
                                                                                width={50}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }
                                                        </Mutation>
                                                        :
                                                        <Mutation mutation={SAVE_DATA}>
                                                            {(companyCreate, { data, loading }) =>
                                                                <div>
                                                                    <Button
                                                                        type="button"
                                                                        size="large"
                                                                        className="btn-orange-gradiant"
                                                                        variant="contained"
                                                                        onClick={() => {
                                                                            if (validateForm(this.state.errors)) {
                                                                                companyCreate({
                                                                                    variables: {
                                                                                        name: this.state.name,
                                                                                        website_url: this.state.websiteUrl,
                                                                                        description: this.state.Description,
                                                                                        logo: this.state.profilePic,
                                                                                        company_industry_type_id: this.state.industry
                                                                                    }
                                                                                }).then((res, loading) => {
                                                                                    console.log(res)
                                                                                    if (res.data.companyCreate.Status.code === 200) {
                                                                                        this.setState({ ...this.state, company: res.data.companyCreate.company });
                                                                                        this.props.history.push({
                                                                                            pathname: '/homepage'
                                                                                        });
                                                                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                    }

                                                                                }).catch((err) => console.log(err));
                                                                            }
                                                                        }} >
                                                                        Save Changes
                                                                </Button>
                                                                    {loading &&
                                                                        <div className="loading">
                                                                            {/* <p className="text-white">saving your awesome video addons</p> */}
                                                                            <Loader
                                                                                type="TailSpin"
                                                                                color="white"
                                                                                height={50}
                                                                                width={50}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }
                                                        </Mutation>
                                                    }
                                                </Col>
                                            </Row>
                                        </Modal.Footer>
                                    </Col>
                                </Modal>
                                <Col md={4}>
                                    <div className="">
                                        <CompanyProfileStrength />
                                        <ExplorePremium />
                                        <CompanyProfileLink />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </ApolloProvider>
            )
        }
    }
}

const SAVE_DATA = gql`
mutation($name : Name! $description :Text $website_url : Url  $logo : Upload $company_industry_type_id : Int){
    companyCreate(Inputs:{
      name : $name 
      website_url : $website_url
      description : $description
      logo : $logo
      company_industry_type_id  : $company_industry_type_id
    }){
      Status {
        code
        message
      }
      company {
        id
        name
        website_url
        description
        website_url
        logo{url}
        Industry{
            id
            context
            name
            name_en
            name_ar
          }
      }
    }
  }
`
const EDIT_DATA = gql`
mutation($name : Name! $description :Text $website_url : Url  $logo : Upload $company_id : Int $company_industry_type_id : Int){
    companyEdit(Inputs:{
            name : $name 
            website_url : $website_url
            description : $description
            logo : $logo
            company : {
                id : $company_id
            }
            company_industry_type_id  : $company_industry_type_id
    }){
      Status{
        code
        message
      }
      company {
        id
        name
        website_url
        description
        website_url
        logo{url}
        Industry{
            id
            context
            name
            name_en
            name_ar
          }
      }
    }
  }  
`

export default withRouter(CompanyProfile);